import { Col, Row, Switch } from "antd";
import { get } from "lodash";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { INSURANCE_PLAN_PARAMS_RULES } from "utils/constants";
import { bindArrayInputProps } from "utils/helpers/input";

const RetroactivityFields = ({
  index,
  values,
  setFieldValue,
  formProps,
  label,
  daysLabel,
  daysPlaceholder,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.INSURANCE_PLAN);
  const daysDefaultHint = t("FORM.CONDITIONS.RETROACTIVITY_DAYS_DEFAULT");
  const enabledPath = `params.${index}.rules.${INSURANCE_PLAN_PARAMS_RULES.RETROACTIVITY_ENABLED}.value`;
  const daysPath = `params.${index}.rules.${INSURANCE_PLAN_PARAMS_RULES.RETROACTIVITY_DAYS}.value`;
  const enabledValue = get(values, enabledPath);
  const enabled = enabledValue === true || enabledValue === "true";

  return (
    <>
      <Row gutter={[16, 16]} align="middle">
        <Col span={4}>{label}</Col>
        <Col span={20}>
          <Switch
            checked={enabled}
            onChange={(checked) => {
              setFieldValue(enabledPath, checked);
              if (!checked) setFieldValue(daysPath, null);
            }}
          />
        </Col>
      </Row>
      {enabled && (
        <Row gutter={[16, 16]} align="middle">
          <Col span={4}>{daysLabel}</Col>
          <Col span={10}>
            <Input
              type="number"
              min={1}
              placeholder={daysPlaceholder}
              {...bindArrayInputProps({
                parent: "params",
                index,
                name: `rules.${INSURANCE_PLAN_PARAMS_RULES.RETROACTIVITY_DAYS}.value`,
                values,
                ...formProps,
              })}
            />
            <div className="c-gray m-top-8">{daysDefaultHint}</div>
          </Col>
        </Row>
      )}
    </>
  );
};

RetroactivityFields.propTypes = {
  index: PropTypes.number.isRequired,
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  formProps: PropTypes.object.isRequired,
  label: PropTypes.string,
  daysLabel: PropTypes.string,
  daysPlaceholder: PropTypes.string,
};

RetroactivityFields.defaultProps = {
  label: "",
  daysLabel: "",
  daysPlaceholder: "",
};

export default RetroactivityFields;
